import { supabase } from "@/lib/supabase/supabaseClient";
import { GetCrmProjectByIdProps } from ".";

export const getCrmProjectById = async ({
  crmProjectId,
}: GetCrmProjectByIdProps) => {
  return await supabase
    .from("crm_project")
    .select("*,crm!inner(*,organisation_crm!inner(*))")
    .eq("id", crmProjectId)
    .maybeSingle()
    .throwOnError()
    .then((res) => {
      if (!res.data) {
        throw new Error("CrmProject not found");
      }
      return res.data;
    });
};
